import type { AxiosRequestConfig } from 'axios'
import { post } from '../base'
import type {
  CreateEventPayload,
  GenerateEventPayload,
  GeneratedEventModel,
  UpdateEventInfoPayload,
} from '@/types/event'
import type {
  CreatedEventModel,
  GenerateFirstEventPayload,
} from '@/types/universe'

class EventService {
  async generateFirstEvent(payload: GenerateFirstEventPayload) {
    return post<GeneratedEventModel[]>(
      '/universe/v2/generateFirstEvent',
      payload,
    )
  }

  async createEvent(payload: CreateEventPayload) {
    return post<CreatedEventModel>('/universe/v2/createEvent', payload)
  }

  async updateEvent(eventId: number, payload: UpdateEventInfoPayload) {
    return post<CreatedEventModel>('/universe/v2/updateEvent', {
      eventId,
      updateInfo: payload,
    })
  }

  async generateEventSuggestion(payload: GenerateEventPayload) {
    return post<GeneratedEventModel[]>(
      '/universe/v2/generateEventSuggestion',
      payload,
    )
  }

  async generateFirstEventSuggestion(whatIf: string, retry?: boolean) {
    return post<GeneratedEventModel[]>(
      '/universe/v2/generateFirstEventSuggestion',
      { whatIf, retry },
      {
        timeout: 120000,
      },
    )
  }

  async generateEventBackgroundImage(
    payload: {
      eventId: number
      backgroundKeywords: string
    },
    config?: AxiosRequestConfig<any>,
  ) {
    return post<{
      presignedUrl: string
      s3Prefix: string
    }>('/universe/v2/generateEventBackgroundImage', payload, config)
  }
}

export const eventService = new EventService()
